export enum ChargeType {
    ONCE_ONLY = 'onceOnlyCharges',
    RECURRING = 'recurringCharges',
    INSTALMENT = 'instalmentCharges',
}

export interface AbstractSummaryCharge {
    offerName: string;
    productName?: string;
    itemName?: string;
    chargeName: string;
    value?: string;
    title: string;
    amount: string;
    overrider?: Overrider;
}

export interface OnceOnlyCharge extends AbstractSummaryCharge {
    chargeType: ChargeType.ONCE_ONLY;
}

export interface RecurringCharge extends AbstractSummaryCharge {
    chargeType: ChargeType.RECURRING;
    frequencyMonths: number;
    validityPeriodMonths: string;
}

export interface InstalmentCharge extends AbstractSummaryCharge {
    chargeType: ChargeType.INSTALMENT;
    frequencyMonths: number;
    numberOfPayments: string;
}

export interface Overrider {
    title: string;
    amount: string;
    chargeName: string;
    validityPeriodMonths: number;
    appliedToCharge?: boolean;
}

export type SummaryCharge = OnceOnlyCharge | RecurringCharge | InstalmentCharge;
